import React from "react";

export default function Footer() {
  return (
    <div className="bg-white shadow-sm p-3 poppins w-100">
      <div className="container">
        <div className="text-center">Copyright@EduSphere 2024</div>
      </div>
    </div>
  );
}
